export default "__VITE_ASSET__BY6lCf64__"